<template>
  <section id="entity-requests-index">
    <Breadcrumbs
      :breadcrumbs="breadcrumbs">

      <div slot="breadcrumbAfter" class="d-flex align-items-center">
        <Searchable class="mr-2" :querySearch.sync="querySearch"/>
      </div>
    </Breadcrumbs>

    <div class="btn btn__floating btn__round__large btn__round__large" v-if="userProfile">
      <va-popover
        :message="$t('entityrequests.title')"
        placement="left"
      >
        <va-button
          @click.prevent="createEntityRequest">
          <i class="fa fa-plus"></i>
        </va-button>
      </va-popover>
    </div>

    <EntityRequestsTable
      v-if="Array.isArray(businessPlans) && businessPlans.length > 0"
      ref="entityRequestsTable"
      :querySearch="querySearch"
      :businessPlans="businessPlans"
      :weekDays="weekDays"
      :userProfile="userProfile"
      @deleteEntityRequest="deleteEntityRequest"
    >

    </EntityRequestsTable>

    <CreateOrUpdateEntityRequestModal
      v-if="isCreatingEntityRequest"
      :businessPlans="businessPlans"
      :userProfile="userProfile"
      :weekDays="weekDays"
      @entity-request-created="onEntityRequestCreated"
      @cancel="onCloseCreateEntityRequestModal"
    >
    </CreateOrUpdateEntityRequestModal>

    <ConfirmationModal v-if="isDeletingEntityRequest"
      :title="$t('entityrequests.delete?')"
      :body="$t('entityrequests.delete_message', {name: this.entityRequestToDelete.entity_name})"
      okClass="btn-danger"
      @modal-confirmed="onConfirmDeleteEntityRequest"
      @modal-canceled="onCancelDeleteEntityRequest"
    >
    </ConfirmationModal>
  </section>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { EntityService } from '@/api/AuthService'
import { EntityRequestService, GlinttHierarchyService } from '@/api/LeadsService'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import Searchable from '@/components/common/Searchable'
import AddressFormInput from '../patients/AddressFormInput'
import EntityRequestsTable from '@/components/entityrequests/EntityRequestsTable'
import CreateOrUpdateEntityRequestModal from '@/components/entityrequests/CreateOrUpdateEntityRequestModal'
import ConfirmationModal from '@/components/common/ConfirmationModal'

export default {
  components: {
    Searchable,
    Breadcrumbs,
    Multiselect,
    AddressFormInput,
    EntityRequestsTable,
    CreateOrUpdateEntityRequestModal,
    ConfirmationModal
  },
  data () {
    return {
      entityRequestToDelete: null,
      isDeletingEntityRequest: false,
      breadcrumbs: [
        { title: this.$t('menu.audiology'), disabled: true },
        { title: this.$t('menu.entityrequests'), disabled: true }
      ],
      querySearch: '',
      businessPlans: [],
      showDeleteConfirmation: false,
      userProfile: null,
      isCreatingEntityRequest: false,
      weekDays: [
        {
          value: 1,
          name: 'weekdays.sunday',
        },
        {
          value: 2,
          name: 'weekdays.monday',
        },
        {
          value: 3,
          name: 'weekdays.tuesday',
        },
        {
          value: 4,
          name: 'weekdays.wednesday',
        },
        {
          value: 5,
          name: 'weekdays.thursday',
        },
        {
          value: 6,
          name: 'weekdays.friday',
        },
        {
          value: 7,
          name: 'weekdays.saturday',
        },
      ],
    }
  },
  methods: {
    deleteEntityRequest: function (entityRequest) {
      this.entityRequestToDelete = entityRequest
      this.isDeletingEntityRequest = true
    },
    onCancelDeleteEntityRequest: function () {
      this.isDeletingEntityRequest = false
      this.$refs.entityRequestsTable.reopenDetails(this.entityRequestToDelete)
      this.entityRequestToDelete = null
    },
    onConfirmDeleteEntityRequest: function () {
      EntityRequestService.delete(this.entityRequestToDelete.id)
        .then(response => {
          this.$refs.entityRequestsTable.refresh()
          this.showToast(this.$t('entityrequests.success.delete'), this.$store.state.successToastOptions)
          this.isDeletingEntityRequest = false
        })
        .catch(errors => this.showToast(this.$t('clusters.messages.something_went_wrong'), this.$store.state.errorToastOptions))
    },
    loadBusinessPlans: function () {
      EntityService.getBusinessPlans()
        .then(businessPlans => { this.businessPlans = businessPlans })
        .catch(errors => console.log(errors))
    },
    loadUserProfile: function () {
      GlinttHierarchyService.getUserProfile(this.$auth.user().id)
        .then(userProfile => {
          this.userProfile = userProfile
          if (this.userProfile == null) {
            this.showToast(this.$t('entityrequests.errors.fail_to_load_user_profile'), this.$store.state.errorToastOptions)
          }
        })
        .catch(errors => {
          console.log(errors)
          this.showToast(this.$t('entityrequests.errors.fail_to_load_user_profile'), this.$store.state.errorToastOptions)
        })
    },
    onCloseCreateEntityRequestModal: function () {
      this.isCreatingEntityRequest = false
    },
    onEntityRequestCreated: function () {
      this.$refs.entityRequestsTable.refresh()
    },
    createEntityRequest: function () {
      this.isCreatingEntityRequest = true
    }
  },
  created () {
    this.loadUserProfile()
    this.loadBusinessPlans()
  }
}
</script>
